<div class="error-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <div class="message-container">
      <p class="main-message">{{ mainMessage }}</p>

      <p class="unlocked-chains-text" *ngIf="unlockedChains.length > 0">
        Unlocked chains: {{ unlockedChains.length }}
      </p>

      <div class="info-box" *ngIf="data.isPartialLockError">
        <mat-icon class="info-icon">info</mat-icon>
        <p>
          When chains contain altruistic donors and alternative patients with partial locks,
          all other chains must be locked before starting a new matchrun.
          Please lock the remaining chains and try again.
        </p>
      </div>

      <div class="info-box" *ngIf="data.isParticipantWarningError">
        <mat-icon class="info-icon">warning</mat-icon>
        <p>
          Active participants where ENIS sync is needed, center assignment is required, or where patients have missing HLA must be resolved before starting a matchrun.
          Please resolve the issues below or set these participants to inactive before starting a matchrun.
        </p>

        <div class="participants-list" *ngIf="data.participants && data.participants.length > 0">
          <div class="participant-section" *ngIf="donorsWithWarnings.length > 0">
            <h4>Donors with warnings ({{ donorsWithWarnings.length }}):</h4>
            <ul>
              <li *ngFor="let donor of donorsWithWarnings">
                <a (click)="navigateToParticipant(donor.id)" class="participant-link">
                  <strong>{{ donor.enisNumber }}</strong>
                </a>: {{ donor.warnings.join(', ') }}
              </li>
            </ul>
          </div>

          <div class="participant-section" *ngIf="recipientsWithWarnings.length > 0">
            <h4>Recipients with warnings ({{ recipientsWithWarnings.length }}):</h4>
            <ul>
              <li *ngFor="let recipient of recipientsWithWarnings">
                <a (click)="navigateToParticipant(recipient.id)" class="participant-link">
                  <strong>{{ recipient.enisNumber }}</strong>
                </a>: {{ recipient.warnings.join(', ') }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="spacer"></div>
    <button mat-raised-button color="primary" (click)="close()">
      OK
    </button>
  </mat-dialog-actions>
</div>
